import styled, { css } from 'styled-components';

import shouldForwardProp from 'configs/shouldForwardProp';

import { TButtonProps } from './Button.types';

const VARIANT_STYLES = {
  primary: css`
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.onPrimary};
    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.colors.primaryHover};
    }
  `,
  secondary: css`
    background-color: transparent;
    color: ${({ theme }) => theme.colors.textPrimary};
    border-color: ${({ theme }) => theme.colors.borderStrong};
    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.colors.surfaceHover};
    }
  `,
  ghost: css`
    background-color: transparent;
    color: ${({ theme }) => theme.colors.textSecondary};
    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.colors.surfaceHover};
      color: ${({ theme }) => theme.colors.textPrimary};
    }
  `,
  danger: css`
    background-color: ${({ theme }) => theme.colors.dangerSurface};
    color: ${({ theme }) => theme.colors.onDanger};
    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.colors.dangerSurfaceHover};
    }
  `,
};

export const StyledButton = styled.button.withConfig({ shouldForwardProp })<TButtonProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.s}px;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  height: ${({ size = 'md' }) => (size === 'sm' ? 32 : 40)}px;
  padding: 0 ${({ theme, size = 'md' }) => (size === 'sm' ? theme.spacing.m : theme.spacing.l)}px;
  border: 1px solid transparent;
  border-radius: ${({ theme }) => theme.borderRadius.sm}px;
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-size: ${({ theme, size = 'md' }) => (size === 'sm' ? theme.fontSizes.s : theme.fontSizes.m)}px;
  font-weight: 600;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    color 0.15s ease;
  white-space: nowrap;

  ${({ variant = 'primary' }) => VARIANT_STYLES[variant]}

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;
